module.exports = __webpack_public_path__ + "img/3D.6814986c.png";